import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nd-footer',
  templateUrl: './nd-footer.component.html',
  styleUrls: ['./nd-footer.component.css']
})
export class NdFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
